var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8693_20366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6382 51.0986H54.4824V53.9227H58.6382V51.0986Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7964 37.2568H26.6406V40.0806H30.7964V37.2568Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7554 24.0011H33.5237V26.0493H51.7554V24.0011Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6415 44.874C40.5593 44.874 38.8652 46.5648 38.8652 48.6433V56.6531H46.4176V48.6433C46.4176 47.637 46.0254 46.6905 45.3132 45.9783C44.6014 45.2661 43.6525 44.874 42.6415 44.874Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6382 37.2568H54.4824V40.0806H58.6382V37.2568Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7539 56.6539H61.3727V34.5254H51.7539V56.6539ZM53.12 36.5739C53.12 36.1968 53.4257 35.8911 53.8028 35.8911H59.3242C59.7014 35.8911 60.0071 36.1969 60.0071 36.5739V40.7634C60.0071 41.1405 59.7013 41.4462 59.3242 41.4462H53.8028C53.4257 41.4462 53.12 41.1404 53.12 40.7634V36.5739ZM53.12 43.4947C53.12 43.1176 53.4257 42.8119 53.8028 42.8119H59.3242C59.7014 42.8119 60.0071 43.1176 60.0071 43.4947V47.6845C60.0071 48.0616 59.7013 48.3673 59.3242 48.3673H53.8028C53.4257 48.3673 53.12 48.0615 53.12 47.6845V43.4947ZM53.12 50.4159C53.12 50.0387 53.4257 49.733 53.8028 49.733H59.3242C59.7014 49.733 60.0071 50.0388 60.0071 50.4159V54.6056C60.0071 54.9828 59.7013 55.2884 59.3242 55.2884H53.8028C53.4257 55.2884 53.12 54.9827 53.12 54.6056V50.4159Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.738 31.1074H51.7578V33.156H62.738V31.1074Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6385 30.4453C40.2629 30.4453 38.3301 32.3805 38.3301 34.7595C38.3301 37.1351 40.2629 39.0676 42.6385 39.0676C45.0175 39.0676 46.9527 37.1351 46.9527 34.7595C46.9527 32.3805 45.0175 30.4453 42.6385 30.4453ZM45.2736 37.3885C45.1402 37.5218 44.9655 37.5885 44.7908 37.5885C44.6161 37.5885 44.4414 37.5218 44.308 37.3885L42.6948 35.7753C42.6767 35.7763 42.6594 35.7807 42.6409 35.7807C42.0751 35.7807 41.6173 35.3229 41.6173 34.7571C41.6173 34.4546 41.7506 34.1855 41.9588 33.9978V31.728C41.9588 31.3509 42.2646 31.0452 42.6417 31.0452C43.0187 31.0452 43.3245 31.3509 43.3245 31.728V33.9985C43.5325 34.1861 43.6658 34.4549 43.6658 34.757C43.6658 34.775 43.6614 34.7918 43.6605 34.8096L45.2737 36.4228C45.5403 36.6896 45.5403 37.1217 45.2736 37.3885Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3863 56.6534V27.4141H34.8926V56.6533H37.4976V48.6436C37.4976 45.8122 39.8042 43.5086 42.6396 43.5086C44.0157 43.5086 45.3073 44.0427 46.2768 45.013C47.2471 45.9829 47.7812 47.2725 47.7812 48.6436V56.6533H50.3863V56.6534ZM42.6366 40.4338C39.5078 40.4338 36.9625 37.8885 36.9625 34.76C36.9625 31.6282 39.5079 29.0802 42.6366 29.0802C45.7684 29.0802 48.3164 31.6282 48.3164 34.76C48.3164 37.8885 45.7684 40.4338 42.6366 40.4338Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5251 31.1074H22.5449V33.156H33.5251V31.1074Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9102 56.6539H33.5287V34.5254H23.9102V56.6539ZM25.2758 36.5739C25.2758 36.1968 25.5816 35.8911 25.9586 35.8911H31.4801C31.8572 35.8911 32.1629 36.1969 32.1629 36.5739V40.7634C32.1629 41.1405 31.8571 41.4462 31.4801 41.4462H25.9586C25.5815 41.4462 25.2758 41.1404 25.2758 40.7634V36.5739ZM25.2758 43.4947C25.2758 43.1176 25.5816 42.8119 25.9586 42.8119H31.4801C31.8572 42.8119 32.1629 43.1176 32.1629 43.4947V47.6845C32.1629 48.0616 31.8571 48.3673 31.4801 48.3673H25.9586C25.5815 48.3673 25.2758 48.0615 25.2758 47.6845V43.4947ZM25.2758 50.4159C25.2758 50.0387 25.5816 49.733 25.9586 49.733H31.4801C31.8572 49.733 32.1629 50.0388 32.1629 50.4159V54.6056C32.1629 54.9828 31.8571 55.2884 31.4801 55.2884H25.9586C25.5815 55.2884 25.2758 54.9827 25.2758 54.6056V50.4159Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1267 59.9996V58.0215H22.125L22.148 59.9996H63.1267Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7964 51.0986H26.6406V53.9227H30.7964V51.0986Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6382 44.1777H54.4824V47.0018H58.6382V44.1777Z",
    fill: "#67D186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7964 44.1777H26.6406V47.0018H30.7964V44.1777Z",
    fill: "#67D186"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8693_20366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(21.625 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school_icon.468569bc17631b240db70c1112773768.svg";
export { ForwardRef as ReactComponent };